import React from "react";
import CompanyGenericSkeleton from "./CompanyGenericSkeleton";

function CompanyDetailSkeleton() {
  return (
    <>
      <CompanyGenericSkeleton />
    </>
  );
}

export default CompanyDetailSkeleton;
